import React from 'react';
import PropTypes from 'prop-types';

const PaymentInformationFiservCheckDisplay = ({ fiserv }) => {
	return (
		<div>
            {fiserv.bankAccountType === "Saving" ? "Savings" : fiserv.bankAccountType} *{fiserv.fundingAccountLastFourDigits}
		</div>
	);
};

PaymentInformationFiservCheckDisplay.propTypes = {
	fiserv: PropTypes.object.isRequired
};

export default PaymentInformationFiservCheckDisplay;
